export default function pointToCoorArray(p) {
  return [p.x, p.y, p.z];
}
